import { CheckCircleFilled, ClockCircleOutlined, CloseCircleFilled, MinusCircleOutlined } from "@ant-design/icons";
import { ButtonT1 } from "../../../components/atoms/Button";
import {
  StepActions,
  StepDescription,
  StepDetail,
  StepHeader,
  StepRowWrap,
  StepTitle,
} from "../SetupGuide.styles";

function StatusIcon({ status }) {
  if (status === "done") {
    return <CheckCircleFilled style={{ color: "#50cd89", fontSize: 18 }} aria-hidden />;
  }
  if (status === "waiting") {
    return <ClockCircleOutlined style={{ color: "#2060ea", fontSize: 18 }} aria-hidden />;
  }
  if (status === "blocked") {
    return <CloseCircleFilled style={{ color: "#f1416c", fontSize: 18 }} aria-hidden />;
  }
  return <MinusCircleOutlined style={{ color: "#a1a5b7", fontSize: 18 }} aria-hidden />;
}

export function StepRow({
  step,
  onNavigate = () => {},
  onSkip = () => {},
  onUnskip = () => {},
  onConfirm = () => {},
  skipLoading = false,
  confirmLoading = false,
}) {
  const showPrimary =
    step.status === "todo" || step.status === "waiting" || step.status === "blocked";

  return (
    <StepRowWrap data-testid={`setup-step-${step.key}`}>
      <StepHeader>
        <StatusIcon status={step.status} />
        <StepTitle>{step.title}</StepTitle>
      </StepHeader>
      <StepDescription>{step.description}</StepDescription>
      {step.detail ? <StepDetail>{step.detail}</StepDetail> : null}
      <StepActions>
        {showPrimary && step.cta_path ? (
          <ButtonT1
            title="Do this"
            $variant="primary"
            type="button"
            onClickCallback={() => onNavigate(step.cta_path)}
          />
        ) : null}
        {step.confirmable && step.status !== "done" ? (
          <ButtonT1
            title="I've done this"
            $variant="secondary"
            type="button"
            loading={confirmLoading}
            onClickCallback={() => onConfirm(step.key)}
          />
        ) : null}
        {step.optional && !step.skipped && step.status !== "done" ? (
          <ButtonT1
            title={step.skip_label || "Skip"}
            $variant="primaryLight"
            type="button"
            loading={skipLoading}
            onClickCallback={() => onSkip(step.key)}
          />
        ) : null}
        {step.skipped ? (
          <ButtonT1
            title="Undo skip"
            $variant="primaryLight"
            type="button"
            onClickCallback={() => onUnskip(step.key)}
          />
        ) : null}
      </StepActions>
    </StepRowWrap>
  );
}
